import { List, Map } from "immutable"
import { getDrupalOvaticLocations, getOvaticLocations } from "../../../../custom_api/api"
import { CombinedLocation } from "./location_overview_page.types"
import { Room } from "../../../../../Shared/api/drupal/drupalTypes"


export const getDrupalRooms: () => Promise<List<CombinedLocation>> = async () => {
    let drupalRes = await getDrupalOvaticLocations()
    let ovaticRes = await getOvaticLocations()

    if (drupalRes == "error" || ovaticRes == "error") return
    if (drupalRes == "loading" || ovaticRes == "loading") return

    const idToDrupal = Map<number, Room>(drupalRes.map(d => [d.ovatic_id, d]))

    return List(ovaticRes
        .filter(o => idToDrupal.has(o.locationID)) // Only show locations for which a Drupal page exists
        .map(o => {                                // Combine Ovatic and Drupal information
            const d = idToDrupal.get(o.locationID)
            const capacity = List(o.seatplans).maxBy(o => o.capacity).capacity
            const eventTypes = o.seatplans.map(s => s.name)

            return {
                ...d,
                ovaticLocation: { ...o, capacity, eventTypes }
            }
        })
    )
}